import AppState, { SCREENS } from '@/js/AppState';
import Button from '@cmp/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Texts from 'react-sdk/Texts';
import classes from './Connect.module.css';
import { FaAngleLeft, FaArrowTurnUp, FaChevronLeft } from 'react-icons/fa6';


const Connect = ({onMailSentCB, onBackCB}) => {

  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  function handleSubmit(e) {
    e.preventDefault()
    setError(null)

    setSubmitting(true)
    tokenByMail(true)
      .then(() => {
        setSubmitting(false)
        onMailSentCB(email)
      })
      .catch((msg) => {
        if (msg == "USER_NOT_FOUND") {
          let pseudo = email
          const {universe} = window.CONFIG.vertx
          if (pseudo.indexOf("@") > -1)
            pseudo = pseudo.substring(0, pseudo.indexOf("@"))
          const user = {
            Universe: universe,
            Mail: email,
            Pseudo: pseudo,
            LastName: "",
            FirstName: ""
          }
          AppState.vertxClient.UserAdd(user, (success, msg, data) => {
            if(success) {
              tokenByMail(true)
                .then(() => {
                  setSubmitting(false)
                  onMailSentCB(email)
                })
                .catch((msg) => {
                  setSubmitting(false)
                  setError("erreur envoi token de connexion")
                })

            } else {
              setSubmitting(false)
              setError("erreur création compte")
            }
          })
        } else {
          setSubmitting(false)
          setError("erreur envoi token de connexion")
        }
      })

  }

  function tokenByMail(tryAddUser) {
    return new Promise((resolve, reject) => {
      const {universe, app} = window.CONFIG.vertx
      AppState.vertxClient.UserConnectPasswordless_GetConnectionTokenByMail(universe, app, email, window.location.href, (success, msg, data) => {
        if(success) {
          resolve(email)
        } else {
          reject(msg)
        }
      })
    })
  }


  function handleChangeMail(e) {
    setEmail(e.target.value.toLowerCase())
  }

  return (
    <div className={classes.Connect}>

      <Button className={classes.back_btn} onClick={onBackCB} icon={<FaAngleLeft  />} />
    <div>
      <h2 className={classes.title}
      dangerouslySetInnerHTML={{__html: Texts.get("connect-descr") }}/>



      <form className={classes.form} onSubmit={handleSubmit}>
        <input name="email" type="email" placeholder={Texts.get("connect-email-placeholder")} value={email} onChange={handleChangeMail}/>

        {error &&
        <div className={classes.error}>{error}</div>}

        <div className={classes.form_button_ctnr} >
          <Button disabled={submitting || (email == "")} >{Texts.get("connect-btn-valid")}</Button>
        </div>

      </form>
</div>


    </div>

  );
};

export default  observer(Connect)
